export default function Step(params) {
  const {
    value,
    otherFields,
    data,
    background,
    backgroundNext,
    isFirst,
    isMiddle,
    isLast
  } = params;
  const stepCell = document.createElement('div');
  stepCell.classList.add('w5-step-cell');
  if (isFirst) stepCell.classList.add('w5-step-cell--first');
  if (isLast) stepCell.classList.add('w5-step-cell--last');
  if (!value && value !== 0) return stepCell;
  const stepCellContent = document.createElement('div');
  stepCellContent.classList.add('w5-step-cell__content');
  if (isFirst) stepCellContent.classList.add('w5-step-cell__content--first');
  if (isLast) stepCellContent.classList.add('w5-step-cell__content--last');
  if (background) stepCellContent.style.backgroundColor = background;
  if (backgroundNext) {
    stepCell.style.backgroundColor = backgroundNext;
  }
  const stepCellContentValues = document.createElement('div');
  stepCellContentValues.classList.add('w5-step-cell__content-values');
  stepCellContentValues.innerText = value;
  const valueTwo = otherFields !== null && otherFields !== void 0 && otherFields.valueTwo ? data === null || data === void 0 ? void 0 : data[otherFields.valueTwo] : '';
  if (valueTwo) {
    const secondValue = document.createElement('span');
    secondValue.classList.add('w5-step-cell__content-extra');
    secondValue.innerText = ' ' + valueTwo;
    stepCellContentValues.appendChild(secondValue);
  }
  stepCellContent.appendChild(stepCellContentValues);
  stepCell.appendChild(stepCellContent);
  if (isFirst || isMiddle) {
    const stepCellArrow = document.createElement('div');
    stepCellArrow.classList.add('w5-step-cell__arrow');
    stepCellArrow.style.borderLeft = `13px solid ${background}`;
    stepCell.appendChild(stepCellArrow);
  }
  return stepCell;
}